import { Inject, Injectable } from '@angular/core';
import {
  ImageModel,
  IStoreService,
  StorePageStore,
  STORE_SERVICE,
} from '@boxx/store-core';
import { Actions, createEffect, ofType } from '@ngrx/effects';
import { of } from 'rxjs';
import {
  catchError,
  mergeMap,
  switchMap,
  withLatestFrom,
} from 'rxjs/operators';
import * as fromImagesActions from './store-images.action';

@Injectable()
export class StoreImagesEffects {
  loadImages$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromImagesActions.loadImagesBeginAction),
      switchMap(() =>
        this.service.loadSiteImages().pipe(
          mergeMap((payload) => [
            fromImagesActions.loadImagesSuccessAction({ payload }),
            fromImagesActions.clearImagesSuccessErrorDataAction(),
          ]),
          catchError((errors) => {
            console.error('StoreEffects.loadImages$ ERROR', errors);
            return of([
              fromImagesActions.loadImagesFailAction({ errors }),
              fromImagesActions.clearImagesSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  loadImageById$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromImagesActions.loadImageByIdBeginAction),
      switchMap((action: any) =>
        this.service.loadSiteImageById(action.id).pipe(
          mergeMap((payload) => [
            fromImagesActions.loadImageByIdSuccessAction({ payload }),
            fromImagesActions.clearImagesSuccessErrorDataAction(),
          ]),
          catchError((errors) => {
            console.error('StoreEffects.loadImageById$ ERROR', errors);
            return of([
              fromImagesActions.loadImageByIdFailAction({ errors }),
              fromImagesActions.clearImagesSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  createImage$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromImagesActions.createImageBeginAction),
      withLatestFrom(this.storePageStore.imagesStore.data$),
      switchMap(([action, imagesData]: [any, ImageModel[]]) =>
        this.service.createSiteImage((action as any).payload).pipe(
          mergeMap((data) => {
            const payload = [data, ...imagesData];
            return [
              fromImagesActions.createImageSuccessAction({ payload }),
              fromImagesActions.clearImagesSuccessErrorDataAction(),
            ];
          }),
          catchError((errors) => {
            console.error('StoreEffects.createImage$ ERROR', errors);
            return of([
              fromImagesActions.createImageFailAction({ errors }),
              fromImagesActions.clearImagesSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  deleteImage$ = createEffect(() =>
    this.actions.pipe(
      ofType(fromImagesActions.deleteImageBeginAction),
      withLatestFrom(this.storePageStore.imagesStore.data$),
      switchMap(([action, imagesData]: [any, ImageModel[]]) =>
        this.service.deleteSiteImage(action.id).pipe(
          mergeMap(() => {
            const payload = imagesData.filter((i) => i.id !== action.id);
            return [
              fromImagesActions.deleteImageSuccessAction({ payload }),
              fromImagesActions.clearImagesSuccessErrorDataAction(),
            ];
          }),
          catchError((errors) => {
            console.error('StoreEffects.deleteImage$ ERROR', errors);
            return of([
              fromImagesActions.deleteImageFailAction({ errors }),
              fromImagesActions.clearImagesSuccessErrorDataAction(),
            ]).pipe(switchMap((d) => d));
          })
        )
      )
    )
  );

  constructor(
    private actions: Actions,
    private storePageStore: StorePageStore,
    @Inject(STORE_SERVICE) private service: IStoreService
  ) {}
}
